<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="credit-create-page">
    <!--  credit form component -->
    <InvoiceForm
      page="update"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></InvoiceForm>
  </div>
</div>
</template>

<script>
import InvoiceForm from "@/components/Form/Invoice/InvoiceForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "InvoiceUpdate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    InvoiceForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(ev) {
      this.submitted = true;
      this.$store
        .dispatch("invoice/updateList", {
          id: this.$route.params.id,
          field: ev.data
        })
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          
          if (this.status_code == 200) {
            //  show if invoice successfully created
            var saved_data = JSON.parse(ev.data);
            if (saved_data.header_details.inv_term_changed) {
              this.inv_settings_details.internal_notes =
                saved_data.header_details.internal_notes;
            }
            if (saved_data.header_details.inv_desc_changed) {
              this.inv_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }
           
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.message,
              type: this.type,
              showCloseButton: true
            });
             //  show if invoice successfully created
            if (ev.pageredirect == "payment") {
              this.$router.push({
                name: "InvoicePayment",
                params: {
                  id: this.updated_id
                }
              });
            } else if(ev.pageredirect != "payment"&&this. RoutePermission(false, '', 'invoice', 'invoice', 'index')){
              this.$router.push({
                name: "InvoiceView",
                params: {
                  id: this.updated_id
                }
              });
            } 
            
           else{
               this.$router.push({
                name: "Invoice"
           })
          } 
            
          } else {
            this.submitted = false;
            this.duplicatecode = true;
            //  showing eror message
          }
          //  code for notificatin display
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "sales/fetchSalesDetails",
        JSON.stringify({
          type:
            routeTo.query.type == "bill_of_supply"
              ? "bill_of_supply"
              : "invoice"
        })
      )
      .then(() => {
          store
      .dispatch("settings/fetchinvoicesettings", {
       stg_menu: "Invoice",
        stg_name: "inv_settings_details"
      });
        next();
      });
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.invoice.code,
      updated_id: state => state.invoice.updated_id,
      message: state => state.invoice.message,
      type: state => state.invoice.type,
      status_code: state => state.invoice.status_code, 
      status_message: state => state.invoice.status_message, 
      status_type: state => state.invoice.status_type 
    }),
    inv_settings_details: {
      get() {
        return this.$store.state.permission.inv_settings_details;
      },
      set(val) {
        this.$store.state.permission.inv_settings_details = val;
      }
    }
  }
};
</script> 

<style>
</style>
